import React, { cloneElement } from 'react'
import { connect } from 'react-redux'

import store from '../../../redux/store'
import getPathValue from '../../../utils/getPathValue'

/**
 * If given a boolean will have that permission ie: true == allowed
 * If given a string will check the user's role schema against the string as a path
 *    periods check the property and commas check multiple paths at once
 *    e.g. "event.read,event.create" returns true iff the user has event read and create permissions
 * @param {string | boolean | function} permissionCheck the check to perform on the user's role
 */
export const hasPermission = permissionCheck => {
  const userRole = getUserRole(store.getState())
  const state = store.getState()
  const user = state && state.data && state.data.user
  // while loading deny permissions
  let hasPermission = false
  if (userRole === false || userRole === null || user === false || user === null) return false
  if (typeof permissionCheck === 'string') {
    // dont check user role path on loading users
    hasPermission = getPathValue(permissionCheck, userRole.roleSchema)
  } else if (typeof permissionCheck === 'boolean') {
    hasPermission = permissionCheck
  } else {
    hasPermission = permissionCheck(userRole)
  }
  return hasPermission
}

/**
 * 
 * @param {Object} props
 * @property {String?} props.label an optional title text to display if the permission is restricted
 * @property {Node} props.children the element that is being restricted
 * @property {Object} props.style custom styles passed to the child
 * @property {String | function | boolean} props.permissionCheck
 *    either a string with the related roleSchema permission for a user comma separated if multiple requirements
 *    or a function given the user that returns a boolean
 *    or a boolean
 *    of whether the user has permission or not  
 */
const RestrictedComponent = props => {
  const { style, permissionCheck, children, label = "You do not have the permissions to do this" } = props
  if (!hasPermission(permissionCheck)) {
    return (
      <span style={style} className="restricted-container" title={label}>
        <span disabled={true} className="restricted">
          {cloneElement(children, { disabled: true })}
        </span>
      </span>
    )
  } else {
    return children
  }
}

const getUserRole = (state) => {
  const user = state.data && state.data.user
  const roles = state.data && state.data.securityRoles
  const userRole = roles && roles.filter(role => role.roleID == user.userRole)[0]
  return userRole
}

const mapStateToProps = state => {
  const user = state.data && state.data.user
  const userRole = getUserRole(state)
  return { userRole, user }
}

export default connect(mapStateToProps)(RestrictedComponent)
